import { ReactNode } from 'react';

export interface ModalState {
  isOldModalOpen?: boolean;
  component?: ModalComponentEnum;
  position?: ModalPosition;
  isFullSizeOnMobile?: boolean;
  oldModalData?: {
    callback?: (data?: any) => void;
    data?: any;
    cancelCallback?: (data?: any) => void;
  };
  onModalUnmountCallBack?: (data?: any) => void;
  isLoaderActive?: boolean;
}

export enum ModalComponentEnum {
  VIEW_GYM_MODAL = 'VIEW_GYM_MODAL',
  ADD_USER_MODAL = 'ADD_USER_MODAL',
  EDIT_USER_MODAL = 'EDIT_USER_MODAL',
  BOOK_ROOM_MODAL = 'BOOK_ROOM_MODAL',
  VIEW_ROOM_MODAL = 'VIEW_ROOM_MODAL',
  CHANGE_GYM_ROOM = 'CHANGE_GYM_ROOM',
  ADD_CREDIT_CARD = 'ADD_CREDIT_CARD',
  FAIL_EVENT_BOOK = 'FAIL_EVENT_BOOK',
  BOOK_EVENT_MODAL = 'BOOK_EVENT_MODAL',
  VIEW_EVENT_MODAL = 'VIEW_EVENT_MODAL',
  EDIT_GUEST_MODAL = 'EDIT_GUEST_MODAL',
  BOOK_LOUNGE_MODAL = 'BOOK_LOUNGE_MODAL',
  VIEW_LOUNGE_MODAL = 'VIEW_LOUNGE_MODAL',
  INVITE_GUEST_MODAL = 'INVITE_GUEST_MODAL',
  BOOK_GYM_ROOM_MODAL = 'BOOK_GYM_ROOM_MODAL',
  BOOK_ROOF_TOP_MODAL = 'BOOK_ROOF_TOP_MODAL',
  CHECK_GYM_TOUR_MODAL = 'CHECK_GYM_TOUR_MODAL',
  NEW_SERVICE_CALL_MODAL = 'NEW_SERVICE_CALL_MODAL',
  OPEN_DASHBOARD_AD_MODAL = 'OPEN_DASHBOARD_AD_MODAL',
  BOOK_FITNESS_EVENT_MODAL = 'BOOK_FITNESS_EVENT_MODAL',
  QUESTION_REMOVE_USER_MODAL = 'QUESTION_REMOVE_USER_MODAL',
  REPEAT_GUEST_END_DATE_MODAL = 'REPEAT_GUEST_END_DATE_MODAL',
  PURCHASE_SUBSCRIPTION_MODAL = 'PURCHASE_SUBSCRIPTION_MODAL',
  QUESTION_CANCEL_ALLOC_MODAL = 'QUESTION_CANCEL_ALLOC_MODAL',
  EDIT_REPEATABLE_GUEST_MODAL = 'EDIT_REPEATABLE_GUEST_MODAL',
  QUESTION_REMOVE_GUEST_MODAL = 'QUESTION_REMOVE_GUEST_MODAL',
  NO_MEDICAL_DECLARATION_MODAL = 'NO_MEDICAL_DECLARATION_MODAL',
  OPEN_CREDIT_USAGE_LIST_MODAL = 'OPEN_CREDIT_USAGE_LIST_MODAL',
  INVITE_REPEATABLE_GUEST_MODAL = 'INVITE_REPEATABLE_GUEST_MODAL',
  MEDICAL_FORM_DECLARATION_MODAL = 'MEDICAL_FORM_DECLARATION_MODAL',
  QUESTION_CANCEL_MEMBERSHIP_MODAL = 'QUESTION_CANCEL_MEMBERSHIP_MODAL',
  UPLOAD_MEDICAL_CERTIFICATE_MODAL = 'UPLOAD_MEDICAL_CERTIFICATE_MODAL',
  GUEST_MANAGEMENT_DUPLICATE_GUEST = 'GUEST_MANAGEMENT_DUPLICATE_GUEST',
  QUESTION_CANCEL_BOOK_EVENT_MODAL = 'QUESTION_CANCEL_BOOK_EVENT_MODAL',
  QUESTION_REMOVE_CREDIT_CARD_MODAL = 'QUESTION_REMOVE_CREDIT_CARD_MODAL',
  MEDICAL_FORM_SUCCESS_MESSAGE_MODAL = 'MEDICAL_FORM_SUCCESS_MESSAGE_MODAL',
  QUESTION_CANCEL_WAITING_LIST_MODAL = 'QUESTION_CANCEL_WAITING_LIST_MODAL',
  QUESTION_FAIL_OPEN_SERVICE_CALL_MODAL = 'QUESTION_FAIL_OPEN_SERVICE_CALL_MODAL',
}

export interface ModalPosition {
  left?: number | string;
  right?: number | string;
  top?: number | string;
  bottom?: number | string;
}
